import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 500 || error.status > 500 || error.status == 0) {
                const customError = {
                    status: error.status,
                    message: 'Something went wrong on our side. Please try again later.',
                };
                return throwError(() => customError);
            }
            // else if (error.status === 400) {
            //     const customError = {
            //         status: error.status,
            //         message: error.message ?? 'Something went wrong, please try again ',
            //     };
            //     return throwError(() => customError);
            // }
            return throwError(() => error);
        })
    );
};
